import {useSelector, useDispatch} from 'react-redux';

// SELECTORS
import {isAltAccoSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

import useNavigateToReviewPage from '@stencil/navigate-to-review-page-dweb';
// TYPES
import {RoomFlavorProps} from '../Room/types';
import {
  DetailsStateShape,
  RplType,
  StaticRoomInfo,
} from '../../../../../../shared/pages/DetailsPageNew/redux/types';

// Components
import RoomFlavor from '../RoomFlavor/RoomFlavor';
// Styles
import * as S from './RoomFlavors.styles';
// Utils
import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';
import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
// Omniture Imports
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';

const StylingFiller: React.FC<{noInclusionsAndSplInstructionsForAnyRoom: boolean}> = ({
  noInclusionsAndSplInstructionsForAnyRoom,
}) => {
  const noOfFillerColumns = noInclusionsAndSplInstructionsForAnyRoom ? 2 : 3;

  return (
    <S.StylingFillerContainer>
      {new Array(noOfFillerColumns).fill(1).map((_, i) => (
        <S.StylingFillerColumn key={i} />
      ))}
    </S.StylingFillerContainer>
  );
};

export type RoomFlavorsPropTypes = {
  isMultiRoom?;
  roomFlavorsList: RoomFlavorProps[];
  roomTypeName: string;
  roomDefaultImage: string;
  noInclusionsAndSplInstructionsForAnyRoom: boolean;
  handlOpenCalendar?: () => {};
  roomCode: string;
};

export type QueryParamsForReviewUrlPropsTypes = {
  hc: DetailsStateShape['vhid'];
  vert: 'hotels';
  strQry: string;
  v: string;
  rtc: string;
  rpc: string;
  fwdParams: string; // stringified forward params
  newui: 'True';
  pah: 'new' | null;
  code: string; // promo code 'pc'
  pay_mode: RplType['pm'];
  gds: 'true';
  rtn: StaticRoomInfo['type_name'];
  gseg: RplType['gseg'];
  cot: RplType['cot'];
  hmd: RplType['hmd'];
  gsv: RplType['gsv'];
  hOfferCode: string | number;
  hotelName: string;
  hotelArea: string;
  cityCode: string;
  gtv: string;
};

const RoomFlavors: React.FC<RoomFlavorsPropTypes> = ({
  isMultiRoom,
  roomFlavorsList,
  roomTypeName,
  roomDefaultImage,
  noInclusionsAndSplInstructionsForAnyRoom,
  handlOpenCalendar = () => {},
  roomCode = '',
}) => {
  const isAltAcco = useSelector(isAltAccoSelector);
  const [navigatorNew] = useNavigateToReviewPage();
  const dispatch = useDispatch();

  const navigateToReviewPageCaller = descBlockInput => {
    const {rootLevelInfo, ...selectedRoomData} = descBlockInput;
    navigatorNew({
      selectedRoomInfo: [
        {
          ...selectedRoomData,
        },
      ],
      rootLevelInfo: {
        ...rootLevelInfo,
      },
    });
  };

  /**
   * CANCELLATION POLICY URL CALCULATION
   */

  return (
    <S.RoomFlavorsContainer
      className="room-flavor-container"
      flexGrowShrink={noInclusionsAndSplInstructionsForAnyRoom ? 2 : 3}
      isMultiRoom={isMultiRoom}
      isNoInclusions={noInclusionsAndSplInstructionsForAnyRoom}
    >
      {roomFlavorsList.map((roomFlavor, index) => {
        const {roomTypeCode, pc, ratePlanInfo = {}} = roomFlavor;

        return (
          <RoomFlavor
            key={roomFlavor.uid ? roomFlavor.uid : index}
            roomDefaultImage={roomDefaultImage}
            roomFlavor={{...roomFlavor, index, lastIndex: roomFlavorsList.length - 1, roomTypeName}}
            noInclusionsAndSplInstructionsForAnyRoom={noInclusionsAndSplInstructionsForAnyRoom}
            selectRoomClickHandler={() => {
              scrollToEl(
                isAltAcco
                  ? detailsNavigationIdsAndValues.stays.id
                  : detailsNavigationIdsAndValues.rooms.id,
                {duration: 0},
              );

              navigateToReviewPageCaller({
                ratePlanArr: [ratePlanInfo],
                roomLevelInfo: {roomCode: roomTypeCode},
                rootLevelInfo: {searchType: 'E', promoCode: pc},
              });

              dispatch(
                omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.selectRoom, {
                  pageVitals: {
                    details: {
                      mealPlanCode: roomFlavor?.mealPlanCode,
                      isEliteRatePlan: roomFlavor?.isPackageOption,
                    },
                  },
                }),
              );
            }}
            handlOpenCalendar={handlOpenCalendar}
            roomCode={roomCode}
          />
        );
      })}
      {/* styling filler div */}
      <StylingFiller
        noInclusionsAndSplInstructionsForAnyRoom={noInclusionsAndSplInstructionsForAnyRoom}
      />
    </S.RoomFlavorsContainer>
  );
};

export default RoomFlavors;
